import './index.css';

import { Box, Divider } from '@mui/material';

import Charging from 'assets/lotties/nowcharging.json';
import { LocalizationKeys } from 'assets/localizations/localizationKeys';
import LottiePlayer from 'components/LottiePlayer';
import { MTypography } from 'components/MTypography';
import React from 'react';
import SuccessAnimationData from 'assets/lotties/success.json';
import { TransactionsDetailData } from 'services/centralServerService/data-contracts';
import UnplugAnimationData from 'assets/lotties/plug_cable.json';
import { observer } from 'mobx-react';

export const SessionStatus: React.FC<{ session: TransactionsDetailData }> =
    observer(({ session }) => {
        const isReadyToUnplug = React.useMemo(() => {
            const progress = +(
                (100 *
                    (session.currentCumulatedRoundedPriceInclVat ||
                        session.currentCumulatedRoundedPrice ||
                        0)) /
                session.targetTotalCost
            ).toFixed(2);
            return progress >= 100;
        }, [session]);
        const isSessionStopped = React.useMemo(() => {
            return !!session?.stop?.totalDurationSecs;
        }, [session]);

        return (
            <Box
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'center'}
                marginBottom={2}
            >
                <Box
                    p={1}
                    position="relative"
                    display={'flex'}
                    flexDirection={'row'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: '5vh',
                            paddingRight: '0.5rem',
                        }}
                        className="session-status-animation"
                    >
                        <LottiePlayer
                            animationData={
                                isReadyToUnplug
                                    ? UnplugAnimationData
                                    : isSessionStopped
                                    ? SuccessAnimationData
                                    : Charging
                            }
                            loop={!isSessionStopped}
                        />
                    </Box>
                    <MTypography
                        sx={{
                            display: 'inline',
                            fontWeight: 600,
                            fontSize: '1rem',
                            // paddingTop: '0.5rem',
                            flex: 1,
                        }}
                        color="text.secondary"
                    >
                        {isReadyToUnplug
                            ? LocalizationKeys.ReadyToUnplug
                            : isSessionStopped
                            ? LocalizationKeys.SessionCompleted
                            : LocalizationKeys.SessionInProgress}
                    </MTypography>
                </Box>
                <Divider />
            </Box>
        );
    });
